import { useCallback, useState } from "react";

export function useTableState(defaultLimit = 10) {
	const [page, setPage] = useState(1);
	const [limit, setLimit] = useState(defaultLimit);
	const [search, setSearch] = useState("");

	// Stable identities: SearchInput debounces on `onSearch`, so a fresh function
	// on every render would keep restarting its timer.
	const onSearch = useCallback((value: string) => {
		setSearch(value);
		setPage(1);
	}, []);

	const onPageChange = useCallback((nextPage: number, nextLimit: number) => {
		setPage(nextPage);
		setLimit(nextLimit);
	}, []);

	const resetPage = useCallback(() => setPage(1), []);

	return { page, limit, search, onSearch, onPageChange, resetPage };
}
